import { ActivatedRouteSnapshot, Route, RouterStateSnapshot, UrlSegment } from "@angular/router";
// eslint-disable-next-line no-restricted-imports
import { NgxPermissionsData, RedirectTo, RedirectToFn, ngxPermissionsGuard } from "ngx-permissions";

export interface FeatureFlagsGuardData {
    has?: string | string[];
    except?: string | string[];
    redirectTo?: RedirectTo | RedirectToFn;
}

export function featureFlagsGuard(route: ActivatedRouteSnapshot & Route, state: RouterStateSnapshot & UrlSegment[]) {
    const featureFlags: FeatureFlagsGuardData | undefined = route.data?.["featureFlags"];

    if (featureFlags) {
        const permissions: NgxPermissionsData = {};

        if (featureFlags?.has) {
            permissions.only = featureFlags?.has;
        }

        if (featureFlags?.except) {
            permissions.except = featureFlags?.except;
        }

        route.data["permissions"] = permissions;
        delete route.data["featureFlags"];
    }

    return ngxPermissionsGuard(route, state);
}
